<template>
  <section :class="{ print }" class="report-app">
    <div v-if="!isPrint" class="mb-5">
      <b-card title="Report">
        <b-row>
          <b-col>
            <b-form-group label="Sito">
              <b-form-select :options="sitesOptions" v-model="siteGuid"></b-form-select>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="Mese">
              <b-select :options="months" v-model="dateMonth"></b-select>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="Anno">
              <b-select :options="years" v-model="dateYear"></b-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div v-if="siteGuid" class="report-container">
      <div class="page" v-if="isPrint">
        <img class="page-header" src="/static/report/top.png" style="width: 100%" />

        <b-row style="margin: 200px 0 100px 0">
          <b-col class="text-right">
            <img src="/static/report/logo.png" style="width: 300px" />
          </b-col>
        </b-row>

        <b-row style="margin-bottom: 100px">
          <b-col class="text-right">
            Report mensile:
            <br />

            <br />
            {{ monthName }}
          </b-col>
        </b-row>

        <b-row style="margin-bottom: 100px">
          <b-col class="text-right">
            <span class="customer">{{ customerName }}</span>

            <br />

            <span>{{ site.name }}</span>

            <br />

            <span>{{ site.addressStreetName }}, {{ site.addressStreetNumber }}</span>

            <br />
            {{ site.addressTown }} - {{ site.addressState }}
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-right">
            Referente tecnico Volta Consulting
            <br />
            Ing. Daniele Bonato/Ing. Laura Messineo
          </b-col>
        </b-row>
      </div>

      <div class="page">
        <page-header :month="month" />

        <h2>1 Executive summary</h2>

        <fabbisogno :tep="tep" />

        <fabbisogno-energetico-elettrico v-if="hasEE" :tep="tep" />

        <fabbisogno-termico :tep="tep" v-if="hasTerm" />
      </div>

      <div class="page" v-if="showIPG">
        <page-header :month="month" />

        <indicatori-performance :ipg="ipg" :month="month" :siteGuid="siteGuid" />
      </div>

      <div class="page">
        <page-header :month="month" />

        <h2>2 Dettaglio Energia Elettrica</h2>

        <energy-summary :month="month" :siteGuid="siteGuid" vector="EE" :index="2" />
      </div>

      <div class="page">
        <page-header :month="month" />

        <ripartizione :month="month" :siteGuid="siteGuid" :index="2" vector="EE" />
      </div>

      <div class="page" v-if="hasGas">
        <page-header :month="month" />

        <h2>3 Dettaglio Gas</h2>

        <energy-summary :month="month" :siteGuid="siteGuid" :index="3" vector="gas" />
      </div>

      <div class="page" v-if="hasGasDetails">
        <page-header :month="month" />

        <ripartizione :month="month" :siteGuid="siteGuid" :index="3" vector="gas" />
      </div>

      <div class="page" v-if="showIPG">
        <page-header :month="month" />

        <h2>4 Indicatori di performance</h2>

        <indexes
          v-for="(ind, i) in indexVectors"
          :index_index="i + 1"
          :key="ind"
          :ipg="ipg"
          :ip="ip"
          :month="month"
          :siteGuid="siteGuid"
          :index="4"
          :vector="ind"
        />
      </div>

      <div id="page-footer" v-if="isPrint">
        Volta Consulting S.r.l. Via Grosio, 10/10 - 20151 Milano (MI) Tel: 02 2506 0322 Mail: info@voltaconsulting.it
      </div>
    </div>
  </section>
</template>

<script>
import PageHeader from "./0_Header";
import Fabbisogno from "./A_Fabbisogno";
import FabbisognoEnergeticoElettrico from "./B_FabbisognoEE";
import FabbisognoTermico from "./C_FabbisognoTermico";
import IndicatoriPerformance from "./D_IndicatoriPerformance";
import EnergySummary from "./E_Summary";
import Ripartizione from "./G_Ripartizione";
import Indexes from "./H_Indexes";

var moment = require("moment");

export default {
  name: "Report",
  components: {
    Fabbisogno,
    FabbisognoEnergeticoElettrico,
    FabbisognoTermico,
    IndicatoriPerformance,
    EnergySummary,
    Ripartizione,
    PageHeader,
    Indexes,
  },
  data() {
    return {
      vectors: {},
      tep: [],
      siteGuid: null,
      month: null,
      ipg: {},
      ip: {},
      showIPG: false,
      print: false,
      reportData: {},
      dateMonth: null,
      dateYear: null,
      hasTerm: false,
    };
  },
  created() {
    this.dateMonth = moment().subtract(1, "months").format("MM");
    this.dateYear = moment().format("YYYY");

    if (this.findGetParameter("month")) {
      this.month = this.findGetParameter("month");
    } else {
      this.month = this.dateMonth + "-" + this.dateYear;
    }

    this.dateMonth = moment(this.month, "MM-YYYY").format("MM");
    this.dateYear = moment(this.month, "MM-YYYY").format("YYYY");

    if (this.findGetParameter("site")) {
      this.siteGuid = this.findGetParameter("site");
    }
  },
  watch: {
    siteGuid() {
      if (this.siteGuid) this.refresh();
    },
    dateMonth() {
      if (this.siteGuid) this.month = this.dateMonth + "-" + this.dateYear;
    },
    dateYear() {
      if (this.siteGuid) this.month = this.dateMonth + "-" + this.dateYear;
    },
    tep() {
      this.hasTerm = this.tep.find((item) => item.thermal) != undefined;
    },
    month() {
      this.refresh();
    },
  },
  methods: {
    refresh() {
      if (!this.siteGuid) return;

      var params = {
        fromMonth: this.month,
        toMonth: this.month,
        siteGuid: this.siteGuid,
      };

      this.$store.dispatch("charts/tepAll", params).then((data) => {
        if (!data.data) {
          this.$notify({
            type: "error",
            text: data.message,
            title: "Errore",
          });
          return;
        }

        this.tep = data.data;
      });

      var ipgParams = {
        siteGuid: this.siteGuid,
        fromMonth: moment(this.month, "MM-YYYY").subtract(3, "years").format("MM-YYYY"),
        toMonth: this.month,
      };

      this.$store.dispatch("report/ipg", ipgParams).then((data) => {
        this.ipg = data;
        if (this.ipg.items) this.showIPG = true;
      });

      this.$store.dispatch("report/ip", ipgParams).then((data) => {
        this.ip = data;
      });
    },
  },
  computed: {
    sites() {
      return this.user.sites;
    },
    user() {
      return this.$store.state.user;
    },
    months() {
      let options = [];
      for (var i = 1; i <= 12; i++) {
        options.push({
          text: moment(i + "", "M").format("MMMM"),
          value: (i + "").padStart(2, "0"),
        });
      }
      return options;
    },
    years() {
      let options = [];
      var currentYear = parseInt(moment().format("YYYY"));
      for (var i = currentYear; i >= currentYear - 5; i--) {
        options.push({
          text: i,
          value: i,
        });
      }
      return options;
    },
    sitesOptions() {
      return this.sites.map((s) => {
        return {
          value: s.guid,
          text: s.name,
        };
      });
    },
    hasEE() {
      return this.tep.find((item) => item.vector == "EE");
    },
    hasGas() {
      return this.tep.find((item) => item.vector == "gas");
    },
    hasGasDetails() {
      return this.$store.state.report.hasGasDetails;
    },
    customerName() {
      return this.$store.state.user.customerName;
    },
    monthName() {
      return moment(this.month, "MM-YYYY").format("MMMM YYYY");
    },
    site() {
      return this.$store.state.user.sites.find((s) => s.guid == this.siteGuid);
    },
    indexVectors() {
      if (!this.ipg.items) return [];

      let ipg = this.ipg.items.map((e) => e.vector);
      if (this.ip.items) ipg = ipg.concat(this.ip.items.map((e) => e.vector));
      return _.uniq(ipg);
    },
    isPrint() {
      return this.$store.state.isReport;
    },
  },
};
</script>

<style>
.print .header {
  display: none;
}
.page-header {
  display: none;
}
.print .page-header {
  display: block;
}
.is-report.sidebar-fixed .sidebar {
  display: none;
}
.is-report.app {
  padding-left: 0;
  font-size: 20px;
}
.is-report .table th,
.is-report .table td {
  padding: 4px;
}
.report-app .table thead th {
  border: 0;
  border-bottom: 2px solid #089baf;
}
.report-app.app,
.is-report.app .content {
  background: #fff;
  color: #666;
}
.is-report section.report-section {
  margin-bottom: 80px;
}
@media print {
  html,
  body {
    width: 210mm;
  }
  .page {
    page-break-after: always;
  }
  .table thead th {
    background: #246284 !important;
    padding: 2px 4px;
  }
}
@page {
  margin: 10mm 16mm 10mm 16mm;
  size: auto;
}

.is-report table.grid {
  width: 100%;
}
.is-report table.grid .col-tiny {
  width: 200px;
}
.is-report table.grid .col-small {
  width: 300px;
  min-height: 300px;
}
.is-report table.grid .col-small2 {
  width: 500px;
}
.is-report table.grid .col-mid {
  width: 50%;
}
.is-report table .pie-wrap {
  width: 300px;
}
.is-report table .pie-wrap2 {
  width: 200px;
}
table.grid .report-arrow {
  text-align: center;
}
table.grid .report-arrow img {
  width: 32px;
}
.report-app table.table td {
  border-right: 1px solid #f0f0f0;
  padding: 0 10px;
  vertical-align: middle;
}
.report-app table.table td .legend {
  font-size: 40px;
  line-height: 1;
}
.report-app table.table tr td:last-of-type {
  border-right: 0;
}
.report-app .page h2 {
  color: #089baf;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
}
.report-app .page h3 {
  color: #ef4347;
  font-size: 20px;
  font-weight: bold;
}
.report-app .page h4 {
  font-weight: bold;
  margin-bottom: 40px;
}
.report-app .page .detail-title {
  font-weight: bold;
  color: #666;
  line-height: 1.1;
  display: inline-block;
}
.report-app .page .detail-title em {
  text-transform: uppercase;
  font-style: normal;
}
.report-app .page .mb-10 {
  margin-bottom: 10px !important;
}
.report-app .page .in-page-title {
  color: #666;
}
.report-app .page .text-top {
  vertical-align: top;
}
.report-app .page .mt-20 {
  margin-top: 20px;
}
.report-container {
  background: #fff;
  padding: 20px;
  width: 1000px;
  margin: auto;
}
@media screen {
  #page-footer {
    display: none;
  }
}
@media print {
  @page {
    size: landscape;
  }
  .report-container {
    padding: 0;
  }
  #page-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: justify;
    border-top: 2px solid #089baf;
    padding-top: 10px;
    background: #fff;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Report/Report.vue